<template>
<v-autocomplete
    v-model="selectedItems"
    no-data-text="Nenhum registro encontrado"
    no-results-text="Nenhum registro encontrado"
    @change="changeValue"
    :items="items"
    :label="label"
    :placeholder="placeholder"
    :hint="hint"
    :persistent-hint="persistent_hint"
    :disabled="disabled"
    :item-text="item_text"
    :item-value="item_value"
    :loading="loading"
    :readonly="readonly"
    :filter="filter"
    :rules="rules"
    multiple
  >
    <template v-slot:selection="{ item, index }">
      <v-chip small v-if="index < 3">
        <span>{{ item.id_text | formatAbbreviation(20)}}</span>
      </v-chip>
      <span
        v-if="index === 3"
        class="grey--text caption"
      >{{(items.length === selectedItems.length) ? '(Todos)' : ("(+" + (selectedItems.length - 3) + " outros)")}}</span>
    </template>
    <template v-slot:prepend-item>
      <v-list-tile
        ripple
        @click="toggle"
      >
        <v-list-tile-action>
          <v-icon :color="selectedItems.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Selecionar Todos</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-autocomplete>
</template>

<script>
  export default {
    name: 'PSelectMultiple',
    data () {
      return {
        selectedItems: []
      }
    },
    props: {
      value: {
        default: () => { return [] }
      },
      items: {
        default: () => { return [] }
      },
      label: {
        default: 'Items'
      },
      placeholder: {
        default: ''
      },
      hint: {
        default: ''
      },
      item_text: {
        default: 'id_text'
      },
      item_value: {
        default: 'id'
      },
      loading: {
        default: false
      },
      readonly: {
        default: false
      },
      disabled: {
        default: false
      },
      persistent_hint: {
        default: false
      },
      filter: {},
      rules: {}
    },
    methods: {
      changeValue (val) {
        this.$emit('change', val)
      },
      toggle () {
        this.$nextTick(() => {
          if (this.selectedAllItems) {
            this.selectedItems = []
          } else {
            this.selectedItems = this.items.map((item) => item.id)
          }
        })
      }
    },
    watch: {
      value (val) {
        this.selectedItems = val
      },
      selectedItems (val) {
        this.$emit('input', val)
      }
    },
    computed: {
      selectedAllItems () {
        return this.selectedItems.length === this.items.length
      },
      selectedSomeItem () {
        return this.selectedItems.length > 0 && !this.selectedAllItems
      },
      icon () {
        if (this.selectedAllItems) return 'check_box'
        if (this.selectedSomeItem) return 'indeterminate_check_box'
        return 'check_box_outline_blank'
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/PSelectMultiple.vue